/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".infoContainer[_ngcontent-%COMP%]{color:#fff;padding:5px;font-size:16px;border-radius:5px;width:30%;text-align:center}.date-response[_ngcontent-%COMP%]{font-size:small;font-weight:300;padding:1rem 1rem 0}.comment-response[_ngcontent-%COMP%]{padding:1rem 1rem 0}"];
export { styles as styles };
